export function slideUpStyle(enter: number, exit?: number) {
    return {
        defaultStyle: {
            transitionProperty: "transform",
            transitionTimingFunction: "linear",
            transitionDuration: `${enter}ms, ${exit || enter}ms`,
        },
        entering: {
            transform: 'translateY(100%)',
        },
        entered: {
            transform: 'translateY(0)'
        },
        exiting: {
            transform: 'translateY(100%)',
        }
    }
}
export function slideDownStyle(enter: number, exit?: number) {
    return {
        defaultStyle: {
            transitionProperty: "transform",
            transitionTimingFunction: "linear",
            transitionDuration: `${enter}ms, ${exit || enter}ms`,
        },
        entering: {
            transform: 'translateY(-100%)',
        },
        entered: {
            transform: 'translateY(0)'
        },
        exiting: {
            transform: 'translateY(-100%)',
        }
    }
}
export function slideRightStyle(enter: number, exit?: number) {
    return {
        defaultStyle: {
            transitionProperty: "transform",
            transitionTimingFunction: "linear",
            transitionDuration: `${enter}ms, ${exit || enter}ms`,
        },
        entering: {
            transform: 'translateX(-100%)',
        },
        entered: {
            transform: 'translateX(0)'
        },
        exiting: {
            transform: 'translateX(-100%)',
        }
    }
}
export function slideLeftStyle(enter: number, exit?: number) {
    return {
        defaultStyle: {
            transitionProperty: "transform",
            transitionTimingFunction: "linear",
            transitionDuration: `${enter}ms, ${exit || enter}ms`,
        },
        entering: {
            transform: 'translateX(100%)',
        },
        entered: {
            transform: 'translateX(0)'
        },
        exiting: {
            transform: 'translateX(100%)',
        }
    };
}
export function modelStyle(enter: number, exit?: number) {
    return {
        defaultStyle: {
            transitionProperty: "transform",
            transitionTimingFunction: "linear",
            transitionDuration: `${enter}ms, ${exit || enter}ms`,
        },
        entering: {
            // opacity: 0,
            transform: 'translate(0,-25%)',
        },
        entered: {
            // opacity: 1,
            transform: 'translate(0, 0)',
        },
        exiting: {
            // opacity: 0,
            transform: 'translate(0,-25%)',
        }
    }
}
export function fadeStyle(enter: number, exit?: number) {
    return {
        defaultStyle: {
            transitionProperty: "opacity, transform",
            transitionTimingFunction: "linear",
            transitionDuration: `${enter}ms, ${exit || enter}ms`,
        },
        entering: {
            //transform: 'translate(50%, 50%)',
            opacity: 0,
        },
        entered: {
            //transform: 'translate(0, 0)',
            opacity: 1,
        },
        exiting: {
            //transform: 'translate(50%, 50%)',
            opacity: 0,
        }
    };
}

